/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAllHerdsForOfflineQueryResponse, ListAllHerdsForOfflinePathParams, ListAllHerdsForOfflineQueryParams, ListAllHerdsForOffline400, ListAllHerdsForOffline401, ListAllHerdsForOffline403, ListAllHerdsForOffline404, ListAllHerdsForOffline409, ListAllHerdsForOffline500 } from "../../types/livestockController/ListAllHerdsForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAllHerdsForOfflineUrl(organizationId: ListAllHerdsForOfflinePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/herds/all` as const }
  return res
}

/**
 * @summary Full non-paginated herd dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/herds/all}
 */
export async function listAllHerdsForOffline(organizationId: ListAllHerdsForOfflinePathParams["organizationId"], params?: ListAllHerdsForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAllHerdsForOfflineQueryResponse, ResponseErrorConfig<ListAllHerdsForOffline400 | ListAllHerdsForOffline401 | ListAllHerdsForOffline403 | ListAllHerdsForOffline404 | ListAllHerdsForOffline409 | ListAllHerdsForOffline500>, unknown>({ method : "GET", url : getListAllHerdsForOfflineUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}